import { memo } from 'react';
import reactStringReplace from 'react-string-replace';

import { useStyles } from './BoldPhrase.styles';
import { BoldPhraseProps } from './BoldPhrase.types';

export const BoldPhrase = memo(({ text, phraseToBold, boldLevel = 'bold' }: BoldPhraseProps) => {
  const styles = useStyles(boldLevel);

  // eslint-disable-next-line no-useless-escape
  const regexp = new RegExp('(' + phraseToBold.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ')', 'ig');

  return (
    <span>
      {reactStringReplace(text, regexp, (match, i) => (
        <span className={styles.bold} key={i}>
          {match}
        </span>
      ))}
    </span>
  );
});
